export default "__VITE_ASSET__5glmF6Py__"